//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QuantitySelector from '../modules/opus/components/QuantitySelector';
import merge from 'lodash.merge';
import htmlParser from '~/mixins/htmlParser';
import {createEventData} from '@/utils/eventUtils';
import {processConfigurableStockStatus} from '@/utils/productUtils';
import addToCartMixin from '~/mixins/addToCart';

export default {
    components: { QuantitySelector },
    mixins: [htmlParser, addToCartMixin],
    async fetch() {
        const {
            data: {
                products: { items },
            },
        } = await this.$axios.$get(`/product/${this.urlKey}`);
        const item = items[0];

        if (!item) {
            this.$nuxt.error({ statusCode: 404, message: 'Product not found' });
            throw new Error('Product not found');
        }

        const {
            data: {
                products: { items: stockItems },
            },
        } = await this.$axios.$get(`/product/stock/${item.sku}`);
        const stock = stockItems[0];

        const product = item && stock ? merge(item, stock) : item;
        this.product = product;
        this.pimage = product.small_image.url;
        try {
            const skus = this.$storage.getCookie('recently_viewed');
            if (!skus) {
                const sku = [this.product.sku];
                this.$storage.setCookie('recently_viewed', sku);
            } else if (!skus.includes(this.product.sku)) {
                skus.push(this.product.sku);
                this.$storage.setCookie('recently_viewed', skus);
            }
        } catch (e) {
            console.error(e);
        }

        if (product.__typename === 'ConfigurableProduct') {
            processConfigurableStockStatus(product);
        }

        if (process.client) {
            await this.sendViewContentEventData();
        }

        const sku = this.product.sku
        const productId = Buffer.from(this.product.uid, 'base64').toString();

        this.labels = await this.$store.dispatch('productLabel/getProductLabels', { sku, mode: 'PRODUCT', productId });
    },
    data() {
        return {
            product: null,
            pimage: null,
            review: false,
            labels: [],
            backPath: '/',
            tagTypeValue: 'h3',
        };
    },
    async mounted() {
        this.$root.$on('candidateProduct', this.replaceProduct);
        if (process.client) {
            this.tagTypeValue = document.querySelectorAll('h1').length ? 'h3' : 'h1';
            if (this.product) {
                await this.sendViewContentEventData();
            }

            if (this.$gtm) {
                setTimeout(() => {
                    try {
                        this.$gtm.push({ ecommerce: null, items: null });
                        this.$gtm.push({
                            event: 'view_item',
                            ecommerce: {
                                currency: this.product.price_range.minimum_price.final_price.currency,
                                items: [
                                    {
                                        item_id: this.product.sku,
                                        item_name: this.product.name,
                                        price: this.product.price_range.minimum_price.final_price.value,
                                    },
                                ],
                            },
                            value: this.product.price_range.minimum_price.final_price.value,
                            items: [
                                {
                                    id: this.product.sku,
                                    google_business_vertical: 'retail',
                                },
                            ],
                        });
                    } catch (e) {
                        console.error(e);
                    }
                }, 2000);
            }
        }
    },
    created() {
        if (this.$nuxt?.context?.from?.path) {
            this.backPath = this.$nuxt.context.from.path;
        }
    },
    methods: {
        /* Replace mediagallery and description of a chosen simpleitem*/
        replaceProduct(product) {
            this.product.description = product.product.description;
            this.product.media_gallery = product.product.media_gallery;
            this.product.short_description = product.product.short_description;
            this.product.stock_status = product.product.stock_status;
            this.product.id = product.product.id;
        },
        scrollToDescription() {
            this.$scrollTo('#description-section');
        },
        async sendViewContentEventData() {
            try {
                let userData = null;
                const fbc = this.$storage.getCookie('_fbc');
                if (fbc) {
                    userData = {
                        fbc: fbc,
                    };
                }

                const fbp = this.$storage.getCookie('_fbp');
                if (fbp) {
                    userData = {
                        ...userData,
                        fbp: fbp,
                    };
                }

                if (this.$store.state.auth.loggedIn) {
                    let user = this.$store.state.auth.user;
                    if (user) {
                        userData = {
                            ...userData,
                            em: this.$store.state.auth.user.email,
                            fn: this.$store.state.auth.user.firstname,
                            ln: this.$store.state.auth.user.lastname,
                        };
                    }
                }

                const eventData = createEventData(
                    'ViewContent',
                    null,
                    {
                        contents: [
                            {
                                id: this.product.sku,
                                quantity: 1,
                                item_price: this.product.price_range.minimum_price.final_price.value,
                            },
                        ],
                        content_type: 'product',
                        value: this.product.price_range.minimum_price.final_price.value,
                        currency: 'EUR',
                        content_ids: [this.product.sku],
                    },
                    userData,
                );
                await this.$store.dispatch('eventTracking/sendEventData', { eventData });
            } catch (e) {
                console.error(e);
            }
        },
    },
    computed: {
        urlKey() {
            const path = this.$route.params.pathMatch;
            const navigationRoute = path.split('/');
            const urlKey = navigationRoute.length > 1 ? navigationRoute[navigationRoute.length - 1] : path;

            return urlKey;
        },
        shortenedDescription() {
            try {
                if (process.client) {
                    const desc = document.createElement('div');
                    const final = document.createElement('div');

                    desc.innerHTML = this.product.description.html;
                    final.appendChild(desc.firstChild);
                    return final.innerHTML;
                } else {
                    return this.parseTextFromHTML(this.product.description.html) || '';
                }
            } catch (e) {
                return this.product.description.html;
            }
        },
        shortenedDescriptionTextContent() {
            try {
                const desc = document.createElement('div');
                const final = document.createElement('div');

                desc.innerHTML = this.product.description.html;
                final.appendChild(desc.firstChild);
                return final.textContent;
            } catch (e) {
                return this.product.description.html.replace(/(<([^>]+)>)/gi, '');
            }
        },
        shortDescription() {
            try {
                if (process.client) {
                    const html = this.product.short_description.html;
                    const desc = document.createElement('div');
                    desc.innerHTML = html;
                    const li = [...desc.querySelectorAll('li')];
                    const classes = ['py-2', 'px-4', 'odd:bg-gray-100', 'even:bg-white', 'flex', 'items-center'];
                    li.forEach((item) => {
                        item.classList.add(...classes);
                        const text = document.createElement('span');
                        text.innerHTML = item.textContent;
                        const icon = document.createElement('svg');
                        icon.innerHTML =
                            '<svg class="text-primary mr-4" width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                            '  <path d="M2 5L5 8L11 2" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>\n' +
                            '</svg>\n';
                        item.innerHTML = '';
                        item.appendChild(icon.firstChild);
                        item.appendChild(text);
                    });
                    const notify = desc.querySelector('.huom');
                    if (!notify) {
                        return desc.innerHTML;
                    }
                    notify.removeChild(notify.firstChild);
                    notify.classList.remove(...classes);
                    notify.classList.add('bg-[#8b69ff1a]', 'p-4', 'mt-4', 'border-[#8B69FF]', 'bg-[#8b69ff1a]', 'rounded-md', 'border');
                    return desc.innerHTML;
                }
            } catch (e) {
                console.error(e);
            }
        },
        brand() {
            if (this.product) {
                return this.product.custom_attribute_brand;
            }
        },
        /**
         * Find the breadcrumbs that has the most categories
         * @returns {*|*[]}
         */
        category() {
            if (this.product) {
                let len = 0;
                let result = null;
                [...this.product.categories].forEach((item) => {
                    if (item.breadcrumbs?.length && len < item.breadcrumbs?.length) {
                        len = item.breadcrumbs?.length;
                        result = item;
                    }
                });

                if (result) {
                    const lastBreadcrumb = result.breadcrumbs[result.breadcrumbs.length - 1],
                        lastBreadcrumbUid = lastBreadcrumb.category_uid;
                    if (lastBreadcrumbUid !== result.uid) {
                        result.breadcrumbs.push({
                            category_uid: result.uid,
                            category_level: lastBreadcrumb.category_level + 1,
                            category_name: result.name,
                            category_url_path: result.url_path,
                        });
                    }
                }

                return result ? result.breadcrumbs : [];
            }
        },
        crossSellProducts() {
            return this.product.crosssell_products && this.product.crosssell_products.length;
        },
        protectionLevel() {
            try {
                const [data] = [...this.product.custom_attributes].filter((attribute) => attribute['attribute_metadata'].code === 'protection_level');

                return data?.selected_attribute_options?.attribute_option[0].label;
            } catch (e) {}
            return undefined;
        },
    },
    head() {
        function starCount(items) {
            const len = [...items].length;
            const total = [...items].reduce((acc, curr) => {
                const rating = curr.average_rating / 20;
                acc += rating;

                return acc;
            }, 0);

            return parseInt((total / len).toFixed(0)) || 0;
        }

        if (!this.product) {
            return;
        }
        const reviews = this.product.reviews.items;
        const review = reviews.reduce((acc, curr) => {
            const obj = {};
            obj['@type'] = 'Review';
            obj.author = {
                '@type': 'Person',
                name: curr.nickname,
            };
            obj.name = curr.summary;
            obj.description = curr.text;
            const ratingsBreakdown = curr.ratings_breakdown.map((review) => Number(review.value));
            obj.reviewRating = {
                '@type': 'Rating',
                ratingValue: (ratingsBreakdown.reduce((a, b) => a + b, 0) / ratingsBreakdown.length).toFixed(3),
                bestRating: '5',
                worstRating: '0',
            };

            acc.push(obj);

            return acc;
        }, []);

        const aggregateRating =
            this.product.review_count > 0
                ? {
                      '@type': 'AggregateRating',
                      ratingValue: starCount(this.product.reviews.items),
                      ratingCount: this.product.review_count,
                      bestRating: '5',
                      worstRating: '0',
                  }
                : null; // Google accepts only positive value in ratingCount

        const markupJson = {
            '@context': 'https://schema.org',
            '@type': this.product.__typename === 'ConfigurableProduct' ? 'ProductGroup' : 'Product',
            name: this.product.name,
            image: this.product.thumbnail.url,
            description: !this.$fetchState.pending && !this.$fetchState.error && this.shortenedDescriptionTextContent,
            sku: this.product.sku,
            brand: this.product.custom_attribute_brand,
            offers: {
                '@type': 'Offer',
                'priceCurrency': 'EUR',
                'price': this.product.price_range.minimum_price.final_price.value,
                'availability': this.product.stock_status === 'OUT_OF_STOCK' ? 'https://schema.org/OutOfStock' : 'https://schema.org/InStock',
                'url': 'mobiilitukku.fi/' + this.product.url_key,
            }
        };

        if (review.length > 0) {
            markupJson.review = review;
        }

        if (aggregateRating !== null) {
            markupJson.aggregateRating = aggregateRating;
        }

        if (this.product.__typename === 'ConfigurableProduct') {
            markupJson.hasVariant = this.product.variants.map((variant) => {
                const simpleProduct = variant.product;
                const simpleOffers = {
                    '@type': 'Offer',
                    'priceCurrency': 'EUR',
                    'price': this.product.price_range.minimum_price.final_price.value,
                    'availability': this.product.stock_status === 'OUT_OF_STOCK' ? 'https://schema.org/OutOfStock' : 'https://schema.org/InStock',
                    'url': 'https://mobiilitukku.fi/' + this.product.url_key,
                }

                return {
                    '@context': 'https://schema.org',
                    '@type': 'Product',
                    name: simpleProduct.name,
                    image: simpleProduct.thumbnail.url,
                    description: simpleProduct.description.html.replace(/(<([^>]+)>)/gi, ''),
                    sku: simpleProduct.sku,
                    brand: simpleProduct.custom_attribute_brand,
                    offers: simpleOffers,
                }
            });
        }

        function productBreadCrumb(product) {
            if (product) {
                let len = 0;
                let result = null;
                [...product.categories].forEach((item) => {
                    if (item.breadcrumbs?.length && len < item.breadcrumbs?.length) {
                        len = item.breadcrumbs?.length;
                        result = item;
                    }
                });

                if (result) {
                    const lastBreadcrumb = result.breadcrumbs[result.breadcrumbs.length - 1],
                        lastBreadcrumbUid = lastBreadcrumb.category_uid;
                    if (lastBreadcrumbUid !== result.uid) {
                        result.breadcrumbs.push({
                            category_uid: result.uid,
                            category_level: lastBreadcrumb.category_level + 1,
                            category_name: result.name,
                            category_url_path: result.url_path,
                        });
                    }
                }

                return result ? result.breadcrumbs : [];
            }

            return [];
        }

        const breadCrumbs = productBreadCrumb(this.product);

        const breadcrumbJson = {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': breadCrumbs.length > 0 ? breadCrumbs.map((breadcrumb) => {
                return {
                    '@type': 'ListItem',
                    'position': breadcrumb.category_level,
                    'name': breadcrumb.category_name,
                    'item': 'https://mobiilitukku.fi/' + breadcrumb.category_url_path
                }
            }) : []
        }

        const structuredDataScript = [
            {
                type: 'application/ld+json',
                json: markupJson,
            },
            {
                type: 'application/ld+json',
                json: breadcrumbJson,
            },
        ];

        return {
            title: this.product.name,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: !this.$fetchState.pending && !this.$fetchState.error && this.shortenedDescriptionTextContent,
                },
                {
                    hid: 'og:description',
                    name: 'og:description',
                    content: !this.$fetchState.pending && !this.$fetchState.error && this.shortenedDescriptionTextContent,
                },
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.product.name,
                },
                {
                    hid: 'og:image',
                    name: 'og:image',
                    content: !this.$fetchState.pending && !this.$fetchState.error && this.product.thumbnail.url,
                },
            ],
            link: [
                { rel: 'preload', as: 'image', href: this.product.thumbnail.url },
                {
                    hid: 'canonical',
                    type: 'link',
                    rel: 'canonical',
                    href: this.$config.FRONTEND_BASE_URL + '/' + this.product.url_key,
                },
            ],
            script: structuredDataScript,
        };
    },
    fetchKey: 'product-page',
};
